















































import Vue from 'vue'
export default Vue.extend({
  name: 'SummaryImage',
  props: {
    fullName: {
      type: String,
      default: ''
    },
    score: {
      type: Number,
      default: 1
    },
    datasets: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    truoraLogo () {
      return require('@/assets/images/logos-truora-main@3x.png')
    },
    scoresExplanation () {
      return require('@/assets/images/scores/explanation/scores.png')
    },
    scoreImage () {
      const normalizedScore = Math.floor(10 * this.score)
      return require(`@/assets/images/scores/global/score-${normalizedScore}.png`)
    }
  },
  methods: {
    getDatasetImage (dataset: string) {
      return require(`@/assets/images/datasets/${dataset}.png`)
    }
  }
})
